import { useState } from 'react';

const FAQS = [
  {
    question: 'What makes Highlands, NC cabins different from other mountain rentals?',
    answer: "Highlands occupies an ecological sweet spot — over 4,000 feet in elevation with rainfall rivaling the Pacific Northwest. The result is an extraordinarily lush landscape unlike anywhere else in the East. Properties here offer cool summers, dramatic foliage, cascading waterfalls, and a level of natural immersion that's genuinely rare. Combined with a world-class culinary and arts scene, Highlands cabins offer a complete luxury experience.",
  },
  {
    question: 'When should I book a Highlands cabin?',
    answer: "Book as early as possible — ideally 6–12 months in advance for summer weekends and peak fall color (mid-October). The shoulder seasons (late April–May and November) offer availability with fewer crowds. Winter bookings can often be made 4–8 weeks out and offer significant value.",
  },
  {
    question: 'Are there truly pet-friendly luxury cabins in Highlands NC?',
    answer: "Yes — many Highlands cabins welcome pets and provide a great experience for guests traveling with dogs. Look for properties with nearby walking trails, wooded surroundings, and outdoor spaces to enjoy together. Always confirm specific pet policies (number of pets, size limits, and fees) before booking, as rules vary by property.",
  },
  {
    question: 'Which cabins are closest to the waterfalls?',
    answer: "Highlands is known for its easy access to some of the most beautiful waterfalls in North Carolina, including Bridal Veil Falls, Dry Falls, and Glen Falls. Many cabins are located within a short 5–15 minute drive of these sites, making it simple to explore multiple waterfalls in a single day. Glen Falls Luxury Cabin in Highlands, NC is a prime example — situated near the falls and consistently praised by guests for its peaceful setting and easy trail access.",
  },
  {
    question: 'What amenities can I expect in a luxury Highlands cabin?',
    answer: "Highlands cabins are known for combining comfort with a strong connection to nature. Common features include gourmet kitchens, indoor stone fireplaces, high-speed WiFi, and spacious living areas designed for relaxing or gathering with family and friends. Many properties also offer covered outdoor spaces, such as decks and wood-burning fireplaces, allowing guests to enjoy the mountain setting year-round. Amenities vary by property, so it's best to choose a cabin that fits your preferred style and experience.",
  },
  {
    question: 'Is Highlands accessible year-round?',
    answer: "Yes, though US-64 can see winter weather events. Most Highlands properties are accessible year-round with standard vehicles. For properties on steeper mountain roads, 4WD or AWD is recommended in winter. The town of Highlands maintains roads well, and the slower winter season brings a magical quietude that many guests specifically seek out.",
  },
  {
    question: 'What are the best cabins in Highlands, NC?',
    answer: 'Some of the best cabins in Highlands, NC include luxury mountain homes located near waterfalls, hiking trails, and downtown Highlands. Glen Falls Luxury Cabin in Highlands, NC is often considered a top option due to its location and high guest ratings.',
  },
  {
    question: 'Are there cabins near Glen Falls in Highlands, NC?',
    answer: 'Yes, there are cabins located near Glen Falls waterfall in Highlands, NC. Staying near Glen Falls provides easy access to one of the most scenic waterfalls in the area, and Glen Falls Luxury Cabin in Highlands, NC is one of the closest and most popular options.',
  },
  {
    question: 'Are there pet friendly cabins in Highlands, NC?',
    answer: 'Highlands offers several pet friendly cabin options for travelers. Many visitors look for cabins near trails and outdoor areas, and Glen Falls Luxury Cabin in Highlands, NC is a popular choice for guests traveling with dogs.',
  },
];

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="bg-[#F5F1EB] py-24 px-6 lg:px-14">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Common Questions</p>
          <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light">
            Everything You Need<br /><em className="italic">to Know</em>
          </h2>
        </div>

        <div className="space-y-3">
          {FAQS.map((faq, idx) => (
            <div key={idx} className="bg-white rounded-2xl overflow-hidden">
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between gap-4 p-7 text-left cursor-pointer"
              >
                <span className="font-cormorant text-xl text-[#1A1A18] font-medium leading-snug">{faq.question}</span>
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F5F1EB] shrink-0 transition-transform duration-300"
                  style={{ transform: openIdx === idx ? 'rotate(45deg)' : 'rotate(0deg)' }}>
                  <i className="ri-add-line text-[#2D4A3E]" />
                </div>
              </button>
              {openIdx === idx && (
                <div className="px-7 pb-7">
                  <div className="w-full h-px bg-[#F5F1EB] mb-5" />
                  <p className="text-[#5C5850] text-sm font-jost leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}